import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mobileApp/MobileAppPageClient.jsx");
